import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick", "onMouseenter", "onMouseleave"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick", "onMouseenter", "onMouseleave"];
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "star"
  }, null, -1)), _ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 && $data.isUseComp1 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`])
  }, [_withDirectives(_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = $event => $options.typeClick(_ctx.item, 0)),
    style: {
      "text-align": "center"
    },
    class: "type-li",
    onMouseenter: _cache[1] || (_cache[1] = $event => $options.setHover(true, 0)),
    onMouseleave: _cache[2] || (_cache[2] = $event => $options.setHover(false, 0))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      city: $data.isHovered[0]
    })
  }, "全省", 2)], 544), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.typeClick(item, index + 1),
      class: "type-li",
      onMouseenter: $event => $options.setHover(true, index + 1),
      onMouseleave: $event => $options.setHover(false, index + 1)
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        city: $data.isHovered[index + 1]
      })
    }, _toDisplayString(item.itemformdata.title), 3), $options.getChildren(item, 0) ? (_openBlock(), _createElementBlock("ul", {
      key: 0,
      class: _normalizeClass(["ulchild", [$data.ulchildClass]])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(item, 1), (child, ids) => {
      return _openBlock(), _createElementBlock("li", {
        key: ids,
        onClick: _withModifiers($event => $options.childtypeClick(item, index + 1, child, ids), ["stop"])
      }, _toDisplayString(child.title), 9, _hoisted_2);
    }), 128))], 2)) : _createCommentVNode("", true)], 40, _hoisted_1);
  }), 128))], 2)) : _createCommentVNode("", true), _ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 && !$data.isUseComp1 ? (_openBlock(), _createElementBlock("ul", {
    key: 1,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`])
  }, [_withDirectives(_createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = $event => $options.typeClick(_ctx.item, 0)),
    style: {
      "text-align": "center"
    },
    class: "type-li",
    onMouseenter: _cache[4] || (_cache[4] = $event => $options.setHover(true, 0)),
    onMouseleave: _cache[5] || (_cache[5] = $event => $options.setHover(false, 0))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      city: $data.isHovered[0]
    })
  }, "全省", 2)], 544), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.typeClick(item, index + 1),
      class: "type-li",
      onMouseenter: $event => $options.setHover(true, index + 1),
      onMouseleave: $event => $options.setHover(false, index + 1)
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        city: $data.isHovered[index + 1]
      })
    }, _toDisplayString(item.itemformdata.title), 3), $options.getChildren(item, 0) ? (_openBlock(), _createElementBlock("ul", {
      key: 0,
      class: _normalizeClass(["ulchild", [$data.ulchildClass]])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(item, 1), (child, ids) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          active: $data.childIndex === ids
        }),
        key: ids,
        onClick: _withModifiers($event => $options.childtypeClick(item, index + 1, child, ids), ["stop"])
      }, _toDisplayString(child.title), 11, _hoisted_4);
    }), 128))], 2)) : _createCommentVNode("", true)], 40, _hoisted_3);
  }), 128))], 2)) : _createCommentVNode("", true)]);
}